import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { IconModule } from '@spartacus/storefront';

@Component({
  selector: 'sd-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [IconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorSpinnerComponent {
  iconType = CUSTOM_ICON_TYPE;

  @HostBinding('style.--spinner-size')
  @Input()
  size = 14;

  @HostBinding('style.--spinner-weight')
  @Input()
  weight = 2;
}
